import { AlpineComponentTryba } from '../../scripts/alpine/include/global';

interface StickyCtasAlpineData extends AlpineComponentTryba {
    initDisplayStickyCta(): void;
    allowCtaSticky(): void;
    initDynamicLabel(): void;
}


const ctaButtons: HTMLElement | null = document.querySelector('#cta-products-buttons');

export default (): StickyCtasAlpineData => ({
    __stickyPart: null,
    __lastScrollTop: null,
    __fiftyPercentReached: false,
    __appointmentButton: false,
    init() {
        if (this.$store.global.isMobile && document.body.getAttribute('data-type') == 'product') {
            this.__stickyPart = document.querySelector('[x-ref="stickyCta"]');
            if (this.__stickyPart) {
                this.__appointmentButton = this.__stickyPart.querySelector('.btn--contact');
            }
        }
    },
    initDisplayStickyCta() {
        const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
        const lastScrollTop = this.__lastScrollTop || 0;
        this.$store.scroll.isScrollingUp = currentScrollTop < lastScrollTop;
        this.__lastScrollTop = currentScrollTop;
    },
    handleSticky(): void {
        const st = window.scrollY || document.documentElement.scrollTop;
        this.$store.scroll.scrollDown = st >= this.$store.scroll.scrollY;
        this.$store.scroll.scrollUp = st < this.$store.scroll.scrollY;
        this.$store.scroll.scrollY = st;
    },
    allowCtaSticky(): void {
        if (this.$store.global.isMobile) {
            if (ctaButtons) {
                const ctaButtonsBottom = ctaButtons.getBoundingClientRect().bottom;
                if (ctaButtonsBottom < 0) {
                    this.$store.sticky.startStickyCta = true;
                } else {
                    this.$store.sticky.startStickyCta = false;
                }
            } else {
                this.$store.sticky.startStickyCta = true;
            }
        }
    },
    stopSticky(): void {
        if (!this.$store.global.isMobile) {
            const sticky = this.$refs.sticky; // seulement sur la page PDV
            const header = document.querySelector('header');
            if (sticky) {
                const stickyTop = sticky.getBoundingClientRect().top;
                if (stickyTop == 0 && !this.$store.scroll.isScrollingUp) {
                    this.$store.sticky.stickyBlock = false;
                    if (header) {
                        header.classList.add('lg:!opacity-0', 'lg:pointer-events-none');
                    }
                } else {
                    this.$store.sticky.stickyBlock = true;
                    if (header) {
                        header.classList.remove('lg:!opacity-0', 'lg:pointer-events-none');
                    }
                }
            }
        }
    },
    initDynamicLabel(): void {
        if (this.$store.global.isMobile && this.__stickyPart && this.__appointmentButton && !this.__fiftyPercentReached) {
            const totalDocumentHeight = document.documentElement.scrollHeight;
            const scrollPosition = window.scrollY;
            const scrollPercentage = (scrollPosition / totalDocumentHeight) * 100;

            const scrollPercentageToReach = 25; // percentage of the page to reach before
            if (scrollPercentage >= scrollPercentageToReach) {
                this.__fiftyPercentReached = true;
                this.__runDynamicLabels();
            }
        }
    },
    __runDynamicLabels(): void {
        setTimeout(() => {
            this.__runDynamicLabels();
        }, 40000);

        const totalAnimationTime = 10; // seconds of total animation time
        const labelsArray = ['RDV gratuit', 'RDV sans engagement', 'Prendre RDV'];

        for (let i = 0; i < labelsArray.length; i++) {
            setTimeout(
                (i: any) => {
                    if (labelsArray[i] === 'Prendre RDV') {
                        this.__appointmentButton.innerText = 'Prendre RDV';
                    } else {
                        this.__appointmentButton.innerText = labelsArray[i];
                    }
                },
                i * (totalAnimationTime / labelsArray.length) * 1000,
                i,
                this.__appointmentButton,
            );
        }
    },
});
